import React from 'react';
import { CardHeader } from '@/components/ui/card';

export interface ErpCardHeaderProps {
  className?: string;
  children?: React.ReactNode;
}
const ErpCardHeader: React.FC<ErpCardHeaderProps> = ({ className, children, ...props }) => (
  <CardHeader className={className} {...props}>{children}</CardHeader>
);
export default ErpCardHeader;
